export const blogs = [
  {
    id: 1,
    title: "What to See in Paracas in Just One Day (Without Missing Anything)",
    summary: "Discover the must-see places of Paracas in 24 hours: Ballestas Islands, National Reserve, Huacachina, vineyards, and more.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Guide, Tours, Paracas",
    image: "/tour-images/Paracas/paracas-full-day.jpg",
    slug: "what-to-see-in-paracas-in-one-day"
  },

  {
    id: 2,
    title: "Desert Adventure: Sandboarding and Buggying in Paracas",
    summary: "Experience the adrenaline rush of sandboarding and buggy riding along the Dakar route over the Paracas dunes.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Adventure, Nature, Paracas",
    image: "/tour-images/Paracas/sandboard-dakar.jpg",
    slug: "sandboarding-and-buggy-in-paracas",
  },

  {
    id: 3,
    title: "Paracas National Reserve: Complete Guide for Your Visit",
    summary: "Explore red beaches, geological viewpoints, and discover the marine biodiversity of the Paracas National Reserve.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nature, Reserve, Paracas",
    image: "/tour-images/Paracas/reserva-paracas.jpg",
    slug: "paracas-national-reserve",
  },

  {
    id: 4,
    title: "Everything you need to know before visiting the Ballestas Islands",
    summary: "Tips, schedules, and what you can see: penguins, sea lions, seabirds, and the famous Candelabro geoglyph.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nature, Marine life, Paracas",
    image: "/tour-images/Paracas/islas-ballestas.jpg",
    slug: "ballestas-islands-paracas",
  },

  {
    id: 5,
    title: "Private tour in Paracas: exclusivity tailored to you",
    summary: "Enjoy a completely personalized private tour to explore Paracas with your family or private groups.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "VIP, Private, Paracas",
    image: "/tour-images/Paracas/private-tour.jpg",
    slug: "private-tour-in-paracas",
  },

  {
    id: 6,
    title: "Yacht Charter in Paracas: Luxury and freedom at sea",
    summary: "Sail on your own yacht with a customized itinerary, ideal for groups, events, or photography in Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Luxury, Sea, Paracas",
    image: "/tour-images/Paracas/yacht-charter.jpg",
    slug: "yacht-charter-in-paracas",
  },

  {
    id: 7,
    title: "Special Services in Paracas: Scientific Expeditions and Filming",
    summary: "Specialized logistical assistance for research, filming, or environmental work in Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Science, Filming, Paracas",
    image: "/tour-images/Paracas/special-services.jpg",
    slug: "special-services-in-paracas",
  },

  {
    id: 8,
    title: "Flying over the Nazca Lines from Paracas: Is it worth it?",
    summary: "Experience the thrill of flying over the enigmatic Nazca Lines, departing comfortably from Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "History, Nazca, Culture",
    image: "/tour-images/Paracas/nazca-flight.jpg",
    slug: "nazca-lines-from-paracas",
  },

  {
    id: 9,
    title: "Paracas Marine Fauna: Humboldt Penguins, Sea Lions, and More",
    summary: "Admire the incredible marine life of Paracas on a unique tour of the Peruvian Pacific.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Marine Life, Fauna, Paracas",
    image: "/tour-images/Paracas/fauna-marina.jpg",
    slug: "marine-fauna-in-paracas",
  },
  {
    id: 10,
    title: "Flying Over the Nazca Lines from Pisco: Save Time and Enjoy More",
    summary: "Discover a faster way to explore the mysterious Nazca Lines by flying directly from Pisco, avoiding long road trips from Lima or Nazca.",
    date: "June 26, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nazca, Flights, Culture",
    image: "/tour-images/Paracas/nazca-lines-pisco.jpg",
    slug: "nazca-lines-from-pisco"
  },
  {
    id: 11,
    title: "The Enigma of Mount Sierpe",
    date: "2014-04-20",
    author: "Rein Petersen",
    category: "History and Culture",
    summary: "Discover the mysteries of Mount Sierpe and its geoglyph known as the 'Avenue of Holes.' A pre-Incan legacy linked to rain rituals, ancestral deities, and possible messages to the gods.",
    image: "/tour-images/Paracas/montesierpe.jpg",
    slug: "montesierpe"
  },
  {
    id: 12,
    title: "Guano Collectors",
    date: "2014-02-22",
    author: "Rein Petersen",
    category: "History and Culture",
    summary: "The worst enemy is not the smell, heat or exhaustion. As Domingo León explained to us, the worst enemy is dust sticking on the eyebrows, covering our noses and cheeks and turning our face into a rigid mask.",
    image: "/tour-images/Paracas/guano_collectors.jpg",
    slug: "guano-collectors"
  }


];
